import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import Reveal from "@/components/shared/Reveal";
import { useSettings } from "@/components/layout/PublicLayout";
import Seo from "@/components/shared/Seo";
import SpeakerAvatar from "@/components/shared/SpeakerAvatar";

const Intervenants = () => {
  const settings = useSettings();
  const t = settings?.pages?.intervenants || {};
  const { data: editions = [] } = useQuery({ queryKey: ["editions"], queryFn: async () => (await api.get("/editions")).data });
  const featured = editions.find((e) => e.is_active) || editions.find((e) => e.status === "active") || editions.find((e) => e.status === "upcoming");
  const { data: speakers = [], isLoading } = useQuery({
    queryKey: ["speakers", featured?.id],
    queryFn: async () => (await api.get(`/speakers?edition_id=${featured.id}`)).data,
    enabled: !!featured?.id,
  });
  return (
    <>
      <Seo title={t.seo_title || `Intervenants${featured?.year ? " " + featured.year : ""} — FACADES2build`} description={t.seo_description || "Architectes, ingénieurs façade, bureaux d'études et maîtres d'ouvrage : les experts de FACADES2build."} />
      <section className="bg-f2b-black pt-40 pb-16">
        <div className="f2b-container">
          <Reveal><p className="f2b-kicker text-f2b-cyan mb-4">{t.kicker || "Les experts"}</p></Reveal>
          <Reveal delay={0.08}>
            <h1 className="font-display font-bold text-white text-4xl md:text-6xl leading-tight max-w-3xl">
              {t.title || (featured?.year ? `Les intervenants de l'édition ${featured.year}` : "Les intervenants")}
            </h1>
          </Reveal>
          <Reveal delay={0.16}><p className="text-white/70 mt-6 max-w-2xl">{t.lead || "Architectes, ingénieurs façade, bureaux d'études et maîtres d'ouvrage : les experts qui ont construit le programme."}</p></Reveal>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="f2b-container">
          {isLoading ? <p className="text-f2b-gray">Chargement…</p> : speakers.length === 0 ? (
            <p className="text-f2b-gray" data-testid="intervenants-empty">Les intervenants de cette édition seront annoncés prochainement.</p>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {speakers.map((sp, i) => (
                <Reveal key={sp.id} delay={i * 0.04}>
                  <Link to={`/intervenants/${sp.slug}`} className="group block" data-testid={`speaker-card-${i}`}>
                    <div className="aspect-[4/5] overflow-hidden mb-4 border border-f2b-filet">
                      <SpeakerAvatar speaker={sp} className="group-hover:scale-105 transition-transform duration-500" />
                    </div>
                    <p className="text-xs text-f2b-cyan uppercase tracking-wider">{sp.function}</p>
                    <h3 className="font-display font-bold text-f2b-black text-lg mt-1 leading-tight group-hover:text-f2b-cyan transition-colors">{sp.name}</h3>
                    <p className="text-f2b-gray text-sm mt-1">{sp.company}</p>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Intervenants;
